/**
 * FrameCard component constants
 */

// Card dimensions
export const CARD_WIDTH = 310;
export const CARD_MAX_WIDTH = 310;

// Preview dimensions - width matches card width, taller ratio for more preview visibility
export const PREVIEW_WIDTH = CARD_WIDTH;
export const PREVIEW_HEIGHT = Math.round(PREVIEW_WIDTH * (400 / 266)); // ~466px
export const EMAIL_RENDER_WIDTH = 600;
export const EMAIL_SCALE_FACTOR = PREVIEW_WIDTH / EMAIL_RENDER_WIDTH;

// Supported medium types (all mediums currently in the picker)
export const SUPPORTED_MEDIUMS = ["email", "email-mobile", "sms"] as const;

// Clip path styles for beveled corners. Need to use clip path instead of cornerShape because cornerShape only supports all 4 corners.
export const CLIP_PATHS = {
  top: "polygon(20px 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 0 100%, 0 20px)",
  bottom:
    "polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 20px 100%, 0 calc(100% - 20px))",
} as const;
